// ==============================|| OVERRIDES - RADIO ||============================== //

export default function Radio(theme) {
	return {
		MuiRadio: {}
	}
}